import React from "react";
import ReactDOM from "react-dom";
import { FilterContextProvider } from "./inclusion/guide/filters-context";
import Filters from "./inclusion/guide/filters";

const filtersApp = () => {
  return (
    <FilterContextProvider>
      <Filters />
    </FilterContextProvider>
  );
};

export const initGuideFilters = () => {
  ReactDOM.render(filtersApp(), document.getElementById("guide-filters"));
};
